const base = '/admin-auth'

export const auth = {
    login: `${base}/login`,
    forgot_password: `${base}/forgot-password`,
    create_password: `${base}/create-password`,
    validate_password_reset_code: `${base}/validate-password-reset-code`,
    invite_admin: `${base}/invite`
}